let source: EventSource | null = null;
let channel: BroadcastChannel | null = null;
let isLeader = false;

export interface NotificationData {
    id: number;
    message: string;
    created_at: string;
    [key: string]: any;
}

export function initEventSource(): BroadcastChannel {
    if (!channel) {
        channel = new BroadcastChannel("notifications");

        // Lắng nghe tín hiệu từ tab khác
        channel.onmessage = (event: MessageEvent) => {
            if (event.data === "iam_leader") {
                isLeader = false;
            } else if (event.data === "leader_down") {
                if (!isLeader) {
                    becomeLeader(); // nhận làm leader mới
                }
            }
        };

        // Khi tab bị đóng → nếu là leader thì báo cho tab khác
        window.addEventListener("beforeunload", () => {
            if (isLeader) {
                channel?.postMessage("leader_down");
            }
        });
    }

    // Nếu chưa có leader → nhận làm leader
    if (!isLeader && !source) {
        becomeLeader();
    }

    return channel!;
}

function becomeLeader() {
    isLeader = true;
    channel?.postMessage("iam_leader");

    source = new EventSource("http://localhost/push/1/2");

    source.onmessage = (event: MessageEvent) => {
        try {
            const data: NotificationData = JSON.parse(event.data.data);
            channel?.postMessage(data); // phát cho tất cả tab
        } catch (err) {
            console.error("Parse SSE error:", err);
        }
    };

    source.onerror = (err) => {
        console.error("SSE connection error:", err);
    };
}
